// export const BASE_API = 'http://localhost:8888';
// export const BASE_API = 'http://174.138.16.12:8888';
export const BASE_API = 'https://api.misumiprivilege.com';

export const BASE_PATH_API = '';
